"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ComponentWithPartials = _interopRequireDefault(require("../mixins/ComponentWithPartials"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var I18N_PREFIX = 'salesUI.UIPaginator';

var UIPaginator = _react.default.createClass({
  displayName: "UIPaginator",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    className: _propTypes.default.string,
    disabledPageTooltipTitle: _propTypes.default.node,
    maxVisiblePageButtons: _propTypes.default.number,
    onPageChange: _propTypes.default.func.isRequired,
    page: _propTypes.default.number.isRequired,
    pageCount: _propTypes.default.number.isRequired,
    enabledPageLimit: _propTypes.default.number,
    showFirstLastButtons: _propTypes.default.bool.isRequired,
    showButtonLabels: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      maxVisiblePageButtons: 11,
      showFirstLastButtons: false,
      showButtonLabels: true
    };
  },
  getMinAndMaxPageNumbers: function getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount) {
    var buffer = (maxVisiblePageButtons - 1) / 2;
    var min = page - buffer;
    var max = page + buffer;
    var numPagesToShow = Math.min(maxVisiblePageButtons, pageCount);

    if (min < 1) {
      min = 1;
      max = min + maxVisiblePageButtons - 1;
    }

    if (max > pageCount) {
      max = Math.max(pageCount, 1);
      min = max - numPagesToShow + 1;
    }

    return [Math.floor(min), Math.floor(max)];
  },
  goToPage: function goToPage(page) {
    if (page === this.props.page) return;
    this.props.onPageChange((0, _SyntheticEvent.default)(page));
  },
  renderNumberedPages: function renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle) {
    var _this$getMinAndMaxPag = this.getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount),
        _this$getMinAndMaxPag2 = (0, _slicedToArray2.default)(_this$getMinAndMaxPag, 2),
        min = _this$getMinAndMaxPag2[0],
        max = _this$getMinAndMaxPag2[1];

    var links = [];

    for (var currentPage = min; currentPage <= max; currentPage++) {
      var isActive = currentPage === page;
      links.push(_react.default.createElement(_UITooltip.default, {
        disabled: enabledPageLimit == null || enabledPageLimit != null && currentPage <= enabledPageLimit,
        title: disabledPageTooltipTitle,
        key: currentPage - min
      }, _react.default.createElement(_UIButton.default, {
        active: isActive,
        "aria-current": isActive ? 'true' : null,
        className: (0, _classnames.default)('private-paginator__button', 'private-paginator__button--numeric', {
          'private-paginator__button--active': isActive
        }),
        "data-page-number": currentPage,
        disabled: enabledPageLimit != null && currentPage > enabledPageLimit,
        key: currentPage - min,
        onClick: this.partial(this.goToPage, currentPage),
        responsive: false,
        size: "extra-small",
        use: "transparent"
      }, _react.default.createElement("span", {
        className: "sr-only"
      }, isActive ? _I18n.default.text(I18N_PREFIX + ".pageNumber.currentIndicator") : null, _I18n.default.text(I18N_PREFIX + ".pageNumber.description")), currentPage)));
    }

    return links;
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        disabledPageTooltipTitle = _this$props.disabledPageTooltipTitle,
        enabledPageLimit = _this$props.enabledPageLimit,
        maxVisiblePageButtons = _this$props.maxVisiblePageButtons,
        __onPageChange = _this$props.onPageChange,
        page = _this$props.page,
        pageCount = _this$props.pageCount,
        showFirstLastButtons = _this$props.showFirstLastButtons,
        showButtonLabels = _this$props.showButtonLabels,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "disabledPageTooltipTitle", "enabledPageLimit", "maxVisiblePageButtons", "onPageChange", "page", "pageCount", "showFirstLastButtons", "showButtonLabels"]);

    if (page > pageCount) {
      _devLogger.default.warn({
        message: "UIPaginator: page must not exceed pageCount: page={" + page + "} pageCount={" + pageCount + "}",
        key: 'UIPaginator: bad page value'
      });
    }

    var arrowButtonClassName = showButtonLabels ? '' : 'sr-only';
    return _react.default.createElement("nav", (0, _extends2.default)({
      "aria-label": _I18n.default.text(I18N_PREFIX + ".label"),
      className: (0, _classnames.default)('private-paginator', className),
      "data-current-page": page,
      role: "navigation"
    }, rest), _react.default.createElement("span", {
      className: "private-paginator__backward-controls"
    }, showFirstLastButtons ? _react.default.createElement(_UIButton.default, {
      "aria-label": _I18n.default.text(I18N_PREFIX + ".firstPage.description"),
      className: "private-paginator__button",
      "data-first-page": true,
      disabled: page < 2,
      key: "first",
      onClick: this.partial(this.goToPage, 1),
      responsive: false,
      size: "extra-small",
      use: "transparent"
    }, _react.default.createElement(_UIIcon.default, {
      className: "private-paginator__icon",
      name: "first"
    }), _react.default.createElement("span", {
      className: arrowButtonClassName
    }, _I18n.default.text(I18N_PREFIX + ".firstPage.label"))) : null, _react.default.createElement(_UIButton.default, {
      "aria-label": _I18n.default.text(I18N_PREFIX + ".previousPage.description"),
      className: "private-paginator__button",
      "data-prev-page": true,
      disabled: page < 2,
      key: "prev",
      onClick: this.partial(this.goToPage, Math.max(page - 1, 1)),
      responsive: false,
      size: "extra-small",
      use: "transparent"
    }, _react.default.createElement(_UIIcon.default, {
      className: "private-paginator__icon",
      name: "left",
      size: "xs"
    }), _react.default.createElement("span", {
      className: arrowButtonClassName
    }, _I18n.default.text(I18N_PREFIX + ".previousPage.label")))), _react.default.createElement("span", {
      className: "private-paginator__numbers"
    }, this.renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle)), _react.default.createElement("span", {
      className: "private-paginator__forward-controls"
    }, _react.default.createElement(_UIButton.default, {
      "aria-label": _I18n.default.text(I18N_PREFIX + ".nextPage.description"),
      className: "private-paginator__button",
      "data-next-page": true,
      disabled: page >= pageCount || enabledPageLimit != null && page >= enabledPageLimit,
      key: "next",
      onClick: this.partial(this.goToPage, Math.min(page + 1, pageCount)),
      responsive: false,
      size: "extra-small",
      use: "transparent"
    }, _react.default.createElement("span", {
      className: arrowButtonClassName
    }, _I18n.default.text(I18N_PREFIX + ".nextPage.label")), _react.default.createElement(_UIIcon.default, {
      className: "private-paginator__icon",
      name: "right",
      size: "xs"
    })), showFirstLastButtons ? _react.default.createElement(_UIButton.default, {
      "aria-label": _I18n.default.text(I18N_PREFIX + ".lastPage.description"),
      className: "private-paginator__button",
      "data-last-page": true,
      disabled: enabledPageLimit != null ? page >= enabledPageLimit : pageCount === page,
      key: "last",
      onClick: this.partial(this.goToPage, enabledPageLimit != null ? enabledPageLimit : pageCount),
      responsive: false,
      size: "extra-small",
      use: "transparent"
    }, _react.default.createElement("span", {
      className: arrowButtonClassName
    }, _I18n.default.text(I18N_PREFIX + ".lastPage.label")), _react.default.createElement(_UIIcon.default, {
      className: "private-paginator__icon",
      name: "last"
    })) : null));
  }
});

var _default = UIPaginator;
exports.default = _default;
module.exports = exports.default;